export default __webpack_public_path__ + "static/media/029-tom yum.e18f15fb.svg";